// extracted by mini-css-extract-plugin
module.exports = {"profile__addresses":"_3nyQH6cK","margin-top":"_2BC2IgPi","marginTop":"_2BC2IgPi","profile-nav__list-item":"wRdzGQ74","profileNav__listItem":"wRdzGQ74"};